import { Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  RecordContextProvider,
  SaveButton,
  SimpleForm,
} from "react-admin";

const SeatFormShell = ({ record, onSubmit, onCancel, seatPicker }) => (
  <RecordContextProvider value={record ?? {}}>
    <SimpleForm toolbar={false} onSubmit={onSubmit} record={record ?? {}}>
      <Grid container spacing={2}>
        <Grid item xs={12}>{seatPicker}</Grid>
      </Grid>
      <Grid sx={{ display: "flex", gap: 3, mt: 2 }}>
        <Button
          variant="outlined"
          startIcon={<CloseIcon />}
          color="error"
          size="small"
          label="Откажи"
          onClick={onCancel}
        />
        <SaveButton label="Запази" size="small" alwaysEnable />
      </Grid>
    </SimpleForm>
  </RecordContextProvider>
);

export default SeatFormShell;
